import React from 'react';
import MasterMedicinesTableContainer from './containers/MasterMedicinesTableContainer';
import { Body, Container, Header } from '../Shared/Table';
import { HealtheraButton } from '../../healtheraComponents';
import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router';

const MasterMedicineTable = () => {
  const history = useHistory();

  const handleAddNew = () => {
    history.push('/clinics/master-medicines/create');
  };

  return (
    <Container>
      <Header>
        <Typography variant="h4">Master medicines</Typography>
        <HealtheraButton onClick={handleAddNew}>Add new</HealtheraButton>
      </Header>
      <Body>
        <MasterMedicinesTableContainer />
      </Body>
    </Container>
  );
};
export default MasterMedicineTable;
